(function() {
  'use strict';

  function initPhotoSwipe() {
    const galleries = document.querySelectorAll('.product__media-list');
    if (!galleries.length) return;

    galleries.forEach(function(gallery) {
      const items = gallery.querySelectorAll('.product__media-item');
      if (!items.length) return;

      items.forEach(function(item, index) {
        const img = item.querySelector('img');
        if (!img) return;

        item.style.cursor = 'zoom-in';
        item.addEventListener('click', function(e) {
          e.preventDefault();
          openPhotoSwipe(gallery, index);
        });
      });
    });
  }

  function getHighResSrc(img) {
    const src = img.dataset.src || img.currentSrc || img.src;
    return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)\.(jpg|jpeg|png|webp)/i, '_2048x2048.$2');
  }

  function buildSlides(gallery, callback) {
    const items = gallery.querySelectorAll('.product__media-item img');
    const slides = [];
    let loaded = 0;
    const total = items.length;

    if (total === 0) { callback([]); return; }

    items.forEach(function(img, i) {
      const src = getHighResSrc(img);
      const tempImg = new Image();

      tempImg.onload = function() {
        slides[i] = {
          src: src,
          w: tempImg.naturalWidth,
          h: tempImg.naturalHeight,
          alt: img.alt || ''
        };
        loaded++;
        if (loaded === total) callback(slides);
      };

      tempImg.onerror = function() {
        // Fallback sur l'image originale avec dimensions connues
        slides[i] = {
          src: img.src,
          w: img.naturalWidth || 800,
          h: img.naturalHeight || 800,
          alt: img.alt || ''
        };
        loaded++;
        if (loaded === total) callback(slides);
      };

      tempImg.src = src;
    });
  }

  function openPhotoSwipe(gallery, startIndex) {
    if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
      console.warn('PhotoSwipe non chargé');
      return;
    }

    const pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    buildSlides(gallery, function(slides) {
      const options = {
        index: startIndex,
        bgOpacity: 0.95,
        showHideOpacity: true,
        shareEl: false,
        fullscreenEl: false,
        zoomEl: true,
        tapToClose: true,
        tapToToggleControls: true,
        closeOnScroll: false,
        pinchToClose: true,
        history: false,
        getThumbBoundsFn: function(index) {
          const items = gallery.querySelectorAll('.product__media-item img');
          const img = items[index];
          if (!img) return;
          const rect = img.getBoundingClientRect();
          const scrollY = window.pageYOffset || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + scrollY, w: rect.width };
        }
      };

      const pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, slides, options);
      pswp.init();
    });
  }

  document.addEventListener('DOMContentLoaded', initPhotoSwipe);

  document.addEventListener('variant:changed', function() {
    setTimeout(initPhotoSwipe, 300);
  });
})();
